import { defineStore } from 'pinia'


export const useTransactionStore = defineStore('transactionStore', {
  state: () => ({
    transactionType: null,
  }),

  actions: {
    setTransactionType(transactionType: string) {
      this.transactionType = transactionType
    },
  },

  getters: {
    getTransactionType: (state) => state.transactionType
  }
})